module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-register-technician-report/master-register-technician-report.component.scss
// module id = ./src/app/master/master-register-technician-report/master-register-technician-report.component.scss
// module chunks = main